// extracted by mini-css-extract-plugin
export default {"-large":"dhEpTe4KHmV6t6jH3OTj","container":"V2Yf_z4eYKv8GHELjgQ7"};